import { LogManager } from 'aurelia-framework';
import { ConsoleAppender } from 'aurelia-logging-console';
/**
 * A basic logging service that reads the settings from the `appConfiguration` in order to enable
 * or not the console, and to set a specific logging level.
 */
class AppLogger {
  /**
   * @param {AppConfiguration} appConfiguration To read the logging settings.
   */
  constructor(appConfiguration) {
    'inject';

    /**
     * A local reference for the name of the app, so the service can use it as reference for the
     * main logger.
     * @type {string}
     */
    this.mainLoggerName = appConfiguration.get('appName');
    if (appConfiguration.get('loggingEnabled')) {
      LogManager.setLevel(appConfiguration.get('loggingLevel') || 'none');
      LogManager.addAppender(new ConsoleAppender());
    }
  }
  /**
   * Logs a debug message on the console using the main logger.
   * @param {...*} args The elements for the message.
   */
  debug(...args) {
    this._getMainLogger().debug(...args);
  }
  /**
   * Logs an error message on the console using the main logger.
   * @param {...*} args The elements for the message.
   */
  error(...args) {
    this._getMainLogger().error(...args);
  }
  /**
   * Gets an Aurelia logger by its name.
   * @param {string} name The name of the logger.
   * @return {Logger}
   */
  getLogger(name) {
    return LogManager.getLogger(name);
  }
  /**
   * Logs an info message on the console using the main logger.
   * @param {...*} args The elements for the message.
   */
  info(...args) {
    this._getMainLogger().info(...args);
  }
  /**
   * Logs a warning message on the console using the main logger.
   * @param {...*} args The elements for the message.
   */
  warn(...args) {
    this._getMainLogger().warn(...args);
  }
  /**
   * Gets the app main logger, using the `mainLoggerName` property.
   * @return {Logger}
   * @access protected
   */
  _getMainLogger() {
    return this.getLogger(this.mainLoggerName);
  }
}

export { AppLogger };
